import { GenericBackendResponse } from '../genericBackendResponse';
import resolveRealCompanyId from '../../utils/resolveRealCompanyId';

export interface FeatureFlagStatusOutputDto {
	isActive: boolean;
	userHasSeenFeature: boolean;
}

export type CheckFeatureFlagByNameResponse = GenericBackendResponse<FeatureFlagStatusOutputDto>;

const checkFeatureFlagByName = async (
	token: string,
	companyId: string,
	userId: string,
	featureFlagName: string
): Promise<CheckFeatureFlagByNameResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/feature-flags/check/${featureFlagName}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			// 🔴 Sin empresa real no se manda `companyId`: un `"null"` heredado de `localStorage` es
			// truthy y el backend lo comprueba como una empresa ajena (401), apagando la flag.
			// `JSON.stringify` omite el `undefined` (product#85).
			body: JSON.stringify({
				companyId: resolveRealCompanyId(companyId) ?? undefined,
				userId,
				featureFlagName
			})
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result: CheckFeatureFlagByNameResponse = await response.json();
	return result;
};

export default checkFeatureFlagByName;
